"use client";

import { usePathname } from "next/navigation";
import { Suspense } from "react";

import { Footer } from "@/components/layout/footer";
import { Navbar } from "@/components/layout/navbar";
import { AiShoppingAssistant } from "@/components/ai/shopping-assistant";

export function StoreShell({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const isAdmin = Boolean(pathname?.startsWith("/admin"));


  // Admin routes have their own dedicated portal layout without customer shopping chrome
  if (isAdmin) {
    return <>{children}</>;
  }

  return (
    <>
      <Suspense fallback={null}>
        <Navbar />
      </Suspense>
      <main className="flex-1 bg-amazon-page dark:bg-slate-950">{children}</main>
      <Footer />
      <AiShoppingAssistant />
    </>
  );
}
